module.exports = __webpack_public_path__ + "img/chat_bookmark_active.63f1786e.svg";